import { Data } from 'popper.js';
import { AgencyBranchDataProperties, AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { OfflineRequestTypes, ActiveAirlines, ActiveCountries, ActiveSuppliers, ActiveTripTypes, ActivePassengerType, ActiveAirportCity } from './ActiveClasses';
//20-jan-24
import { PassengerFares } from '../Models/FlightSearchResponseProperties';
import { SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { UsersProperties } from './UsersProperties';
//end
export class BaseDataAirOfflineBooking {
  airlineList: ActiveAirlines[] = [];
  countryList: ActiveCountries[] = [];
  supplierList: ActiveSuppliers[] = [];
  tripList: ActiveTripTypes[] = [];
  passengerList: ActivePassengerType[] = [];
  fromAirportList: ActiveAirportCity[] = [];
  toAirportList: ActiveAirportCity[] = [];
  todayLockDate: string = "";
  requestTypesList: OfflineRequestTypes[] = [];
  titleList: TitleList[] = [];

}
export class OfflineBookingListOnlineDetailsOrOffline {
  agencyId: string;
  userId: number;
  onlineBookingId: number;
  isTicketOnline: string;
  isVoidOnline: string;
  isPnrCancelOnline: string;
  isRefund: string;
  ticketReRequest: boolean;

}
export class OfflineBookingAllList {
  offlineBookingId: number;
  onlineBookingId: number;
  requestList: string;
  sector: string;
  status: string;
  pnr: string;
  requestType: number;
  bookingSource: string;
  passName: string;
  travelDate: string;
  creationDate: string;
  tktNo: string;
  requestTypeName: string;
  agencyId: string;
  creationUser: number;
  bookingAgencyId: string;
  agencyName: string;
  modifyDate: string;
  modifyUser: string;
  agencyBranchManagerId: number;
  openByManager: boolean;
  //10-June-24
  groupTicketId:number;
  //end
}
export class TravelClass {
  classType: string = "";
}
export class TitleList {
  title: string;
}
export interface OfflineRequestType {
  offlineRequestTypeId: number;
  typeName: string;
  status: boolean;
  isDeleted: boolean;
  creationUser: string;
  creationDateTime: Date;
  modifyUser: string;
  modifyDateTime?: Date;  // Optional if ModifyDateTime can be null
}
export class OfflineBookingProperties {
  offlineBookingId: number = 0;
  issuingAirline: string = "";
  bookingSource: string = "";
  pnr: string = "";
  journeyTypeId: number = 0;
  agencyBranchId: string = "";
  isApproved: boolean = false;
  isDeleted: boolean = false;
  creationUser: number = 0;
  modifyUser: number = 0;
  remarks: string = "";
  status: number = 0;
  sector: string = "";
  modifyDate: Date = new Date();
  requestTypeId: number = 0;
  route: string = "";
  travelDate: string | Date = "1901-01-01";
  amount: number = 0;
  baseFare: number = 0;
  taxes: number = 0;
  netToCustomer: number = 0;
  netFromSupplier: number = 0;
  serviceCharges: number = 0;
  refundCharges: number = 0;
  totalNetAmount: number = 0;
  approvalRejectionUser: number = 0;
  tktNo: string = "";
  passName: string = "";
  inProgress: boolean;
  bookingPcc: string = "";
  parentHierarchy: string = "";
  supplierCurrency: string = "";
  userBackSystemCustomer: string = "";
  userBackSystemCompanyId: number = 0;
  providerCode: string;
  fareRulesDetails: string;
  generalRules: string;
  offlineBookingRequestId: number = 0;
  refundType: string = "";
  exchangeCurrencyRate: number = 1;
  //10-June-24
  agencyBranchManagerId: number;
  agencyCurrency: string;
  filePaths:string[];
  creationDate: string;
  airlinePrefixCode: string;
  //end
}
export class OfflineBookingTripDetails {

  tripId: number = 0;
  fromAirport: string = "";
  toAirport: string = "";
  offlineBookingId: number = 0;
  travellingDate: string = "";
  rbd: string = "";
  travellingClass: string = "";
  creationUser: number = 0;
  modifyUser: number = 0;
  fromAirportList: ActiveAirportCity[] = [];
  toAirportList: ActiveAirportCity[] = [];

  //20-jan-24
  passengerId: number = 0;
  flightNumber: string = "";
  segmentType: number = 0;
  departureSegment: boolean = false;
  returnSegment: boolean = false;
  multicitySegment: boolean = false;
  departureTime: string = "";
  arrivalDate: string = "";
  arrivalTime: string = "";
  airlineName: string = "";
  flightNo: string = "";
  aircraft: string = "";

}

export class OfflineBookingPassengerDetails {
  offlineBookingPassengerId: number = 0;
  offlineBookingId: number = 0;
  title: string = "";
  firstName: string = "";
  lastName: string = "";
  passengerTypeId: number = 0;
  nationality: string;

  isDeleted: boolean = false;
  creationUser: number = 0;
  modifyUser: number = 0;
  ticketNo: string = "";
  fareValue: number = 0; // base fare
  expiryDate: string = "";
  serviceCharges: number = 0; // markup
  tax: number = 0;
  payable: number = 0;
  modifyDate: Date = new Date();
  titleList: TitleList[] = [];

  profile_Id: number;
  paxGender: string;
  paxDOB: string;
  mobile: string;

  passportValidTo: string;
  passportNumber: string;
  countryOfIssuance: string;
  email: string;
  //20-jan-24
  frequent_Flyer_No: string = "N/A";
  bookingPcc: string = "";
  issuancePcc: string = "";
  supplierCode: string = "";
  agencyBranch: string = "";
  supplierCurrency: string = "";
  supplierCurrencyId: number = 0;
  agencyCurrency: string = "";
  netFromCustomer: number = 0;
  netToSupplier: number = 0;
  profit: number = 0;
  markup: number = 0;
  commissionForSupplier: number = 0;
  discount: number = 0;
  netTotalAmount: number = 0;
  backSystemSupplierServiceId: number = 0;
  backSystemCustomerServiceId: number = 0;
  files: File[] = [];
  imagePaths: string[] = [];
  //end


  //06-feb-24
  exchangeCurrencyRate: number = 0;
  //end
}

//export class OfflineBookingPassengerCount {
//  adult: number = 0;
//  child: number = 0;
//  infant: number = 0;
//  offlineBookingId: number = 0;
//  creationUser: number = 0;
//  //{ get; set; }
//  passengerCountId: number = 0;
//  //{ get; set; }
//}
//10-June-24
export class OfflineBookingWrapper {
  booking: OfflineBookingProperties = new OfflineBookingProperties();
  tripList: OfflineBookingTripDetails[] = [];
  passengerList: OfflineBookingPassengerDetails[] = [];
  agencyId: string;
  creditLimit: number;
  pendingCreditLimit: number;
  passengerFares: PassengerFares[] = [];
  agencyOnline=new AgencyMasterProperties();
  userOnline = new UsersProperties();
  multipleRefunds: OfflineBookingProperties[] = [];
  multipleVoids: OfflineBookingProperties[] = [];
  refundOrVoid: number = 0;
}
//end

export class OfflineBookingList {
  offlineBookingId: number = 0;
  //{ get; set; }
  date: string = "";
  //{ get; set; }
  requestType: string = "";
  //{ get; set; }
  pnr: string = "";
  //{ get; set; }

  route: string = "";
  //{ get; set; }
  airline: string = "";
  //{ get; set; }
  passName: string = "";
  //{ get; set; }
  noOfPass: number = 0;
  //{ get; set; }

  amount: number = 0;
  serviceCharges: number = 0;
  totalNetAmount: number = 0;
  status: string = "";
  ticketNo: string;
  //{ get; set; }

}
//export class PassengerCountList {
//  count: number;
//}

export class OfflineBookingRights {
  canUpdate: boolean = false;
  offlineRefund: boolean = false;
}

export enum StatusInfo {
  Requested = 1,
  Approved = 2,
  Rejected = 3,
  InProgress = 4
}

//10-June-24
export class CheckOfflineTicket {
  inProgress: boolean
  agencyBranchManagerId: number;
}
export class OfflineTicketRequestProp {
  offlineTicketId:number=0;
  bookingSource: string;
  ticketPNR: string;
  issuingAirline: string;
  agencyCurrency: string;
  parentHierarchy: string;
  requestStatus: number;
  requestTypeId: number;
  creationUser: number;
  agencyBranchId: string;
  filePaths:string[]=[];
}
//end
